module.exports = __webpack_public_path__ + "img/complaint-whatsapp.b50ed517.png";